<template>
  <nav class="bottom-nav" role="tablist" :style="{ '--active-color': activeColor }">
    <button
      v-for="tab in NAV_TABS"
      :key="tab.id"
      class="nav-tab"
      :class="{ active: tab.isActive }"
      :style="tab.isActive ? { color: tab.activeColor } : {}"
      role="tab"
      :aria-selected="tab.isActive"
      :aria-label="tab.label"
      @click="goTo(tab)"
    >
      <ion-icon :icon="tab.icon" class="nav-icon" aria-hidden="true" />
      <span class="nav-label">{{ tab.label }}</span>
    </button>
  </nav>
</template>

<script setup lang="ts">
  import { IonIcon } from '@ionic/vue'
  import { computed } from 'vue'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { t } from '@/composables/translateText.js'

  import {
    homeOutline,
    barbellOutline,
    libraryOutline,
    personOutline,
  } from 'ionicons/icons'

  const emit = defineEmits(['bottom-click'])

  const connectionStore = useConnectionStore()
  const isSignedIn = (connectionStore.getDummy == 0)

  const activeColor = '#7F77DD'

  interface NavTab {
    id: string
    label: string
    icon: string
    route: string
    isActive : boolean
    activeColor: string
  }

  const NAV_TABS: NavTab[] = [
    { id: 'home',    label: t('Home'),    icon: homeOutline,    route: 'home_menu',    
                  isActive: true, activeColor: '#7F77DD' },
    { id: 'tactics', label: t('Tactics Gym'), icon: barbellOutline, route: 'tactics_gym_menu', 
                  isActive : true, activeColor: '#1D9E75' },
    { id: 'studio',  label: t('Studio'),  icon: libraryOutline, route: 'studio_menu',  
                  isActive : true, activeColor: '#7F77DD' },
    { id: 'account', label: (isSignedIn) ? t('Account') : t('Sign-In'), icon: personOutline,  route: 'account_menu', 
                  isActive : true, activeColor: '#7F77DD' },
  ]

  function goTo(tab: NavTab) {
      console.log("Bottom TAB click",tab.route)
      emit("bottom-click",tab.route,tab.label,(tab.id == 'home') ? 'home' : 'new_menu')
  }

</script>

<style scoped>
.bottom-nav {
  position: sticky;
  bottom: 0;
  z-index: 100;
  
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  background: #12122a;
  border-top: 0.5px solid #2a2a4a;
  padding-bottom: env(safe-area-inset-bottom);
  flex-shrink: 0;
}

.nav-tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 8px 0 10px;
  background: none;
  border: none;
  color: #555570;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: color 0.15s ease;
}

.nav-tab.active {
  /* color set inline via :style binding per-tab activeColor */
}

.nav-icon {
  font-size: 22px;
}

.nav-label {
  font-size: 10px;
  font-family: inherit;
  line-height: 1;
}
</style>
